import React, { createElement } from "react";
import "./insTable.scss";
const getCell = (colDef, row, currency, rowNumber, isHeaderCell = false) => {
    const key = `${colDef.field}-${colDef.headerName}-${rowNumber}`;
    if (!row) {
        return isHeaderCell
            ? React.createElement("th", { className: colDef.headerClassName, key: key }, colDef.headerName ?? colDef.field)
            : React.createElement("td", { key: key, style: { width: colDef.width }, className: colDef.headerClassName }, colDef.headerName ?? colDef.field);
    }
    return colDef.cellRenderer
        ? React.createElement(colDef.cellRenderer, { key: key, className: isHeaderCell ? colDef.headerClassName : colDef.cellClassName, value: row[colDef.field], dataPoint: row.dataPoint, currency: currency, data: row, colDef: colDef, isHeaderCell: isHeaderCell })
        : createElement("td", { className: colDef.cellClassName, key, style: { width: colDef.width } }, row[colDef.field]);
};
export const InsTable = ({ className, columnDefs, rowData, hasHeader = true, currency, transposed = false }) => {
    const nonEmptyRows = rowData.filter((row) => columnDefs.some((col) => row[col.field]));
    let columns = [], rows = [];
    if (transposed) {
        const [firstColDef] = columnDefs;
        columns = [null].concat(nonEmptyRows).map((row, n) => getCell(firstColDef, row, currency, n, true));
        rows = columnDefs.map((colDef, i) => {
            if (i === 0) {
                return null;
            }
            const cells = [null].concat(nonEmptyRows).map((row, n) => getCell(colDef, row, currency, n, false));
            return React.createElement("tr", { key: i }, cells);
        });
    }
    else {
        columns = columnDefs.map((colDef, n) => getCell(colDef, null, currency, n, true));
        rows = nonEmptyRows.map((row, i) => {
            const cells = columnDefs.map((colDef, n) => getCell(colDef, row, currency, n, false));
            return React.createElement("tr", { key: i }, cells);
        });
    }
    const header = React.createElement("thead", null,
        React.createElement("tr", null, columns));
    return React.createElement("table", { className: `aux-simple-table ins-table variation-grid ${className}`, "aria-label": "Regular" },
        hasHeader && header,
        React.createElement("tbody", null, rows));
};
